const Schedule = () => import('./main.vue')

const meta = {
  requiresAuth: true,
}

export default [
  {
    name: 'schedule.index',
    path: '/schedule',
    component: Schedule,
    meta,
  },
]

